import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { useMemo } from 'react'

import EmptyState from '@/components/EmptyState'
import { getDetailInvestmentsList } from '@/services/sez-regions'
import { ListBasicRequest } from '@/types/sez-regions'
import { useAppSelector } from '@/utils/hooks'

const InvestmentOpportunities: React.FC = () => {
  const router = useRouter()
  const { t } = useTranslation()
  const request: ListBasicRequest = useMemo(() => {
    return {
      params: { slug: String(router.query?.slug), skip: 0, limit: 1000 },
      headers: { 'Accept-Language': String(router.locale) },
    }
  }, [])

  const { data } = useAppSelector(getDetailInvestmentsList.select(request))

  return (
    <div className='container flex w-full flex-col gap-4 lg:gap-8'>
      <h5 className='text-lg font-bold leading-7 text-gray-1 lg:text-2xl lg:leading-8'>
        {t('investment:distributionMaps.detail.investmentOpportunities')}
      </h5>

      <div className='flex flex-col'>
        {data && data?.data.items.length > 0 ? (
          <>
            {data?.data.items.map((item, idx) => (
              <div
                key={item.xid}
                className='flex gap-3 border-t border-t-neutral-border py-3 first:border-t-0'
              >
                <div className='basis-6'>
                  <div className='flex h-6 w-6 items-center justify-center rounded-full bg-yellow'>
                    <span className='text-xxs font-bold leading-normal text-[#5B5B5B]'>{idx + 1}</span>
                  </div>
                </div>

                <div className='flex flex-col gap-1'>
                  <p className='font-medium tracking-[-0.176px] text-gray-1'>{item.title}</p>
                  <p className='text-sm tracking-[-0.084px] text-gray-2'>{item.description}</p>
                </div>
              </div>
            ))}
          </>
        ) : (
          <EmptyState
            title={String(t('common:emptyState.title'))}
            description={String(t('common:emptyState.description'))}
            contentWidth='lg:w-full'
          />
        )}
      </div>
    </div>
  )
}

export default InvestmentOpportunities
